import axios from "axios";
import om from "@/api";

jest.mock("axios");

describe("om", () => {
  afterEach(() => {
    jest.clearAllMocks();
  });

  describe("request", () => {
    it("should make a request to the API", async () => {
      const endPoint = "";
      const body = { data: "example" };
      const mock = false;

      const response = { data: "response" };
      axios.post.mockResolvedValueOnce(response);

      const result = await om.request({ endPoint, body, mock });

      expect(axios.post).toHaveBeenCalledWith(endPoint, body);
      expect(result).toEqual(response);
    });
  });
});
